export const DRAG_FILES_KEY = 'DRAG_FILES';
